/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Card } from './Card';
import {
    CardFromJSON,
    CardFromJSONTyped,
    CardToJSON,
} from './Card';

/**
 * 
 * @export
 * @interface RegisterCardOutput
 */
export interface RegisterCardOutput {
    /**
     * 
     * @type {Card}
     * @memberof RegisterCardOutput
     */
    card?: Card;
    /**
     * 
     * @type {Error}
     * @memberof RegisterCardOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the RegisterCardOutput interface.
 */
export function instanceOfRegisterCardOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegisterCardOutputFromJSON(json: any): RegisterCardOutput {
    return RegisterCardOutputFromJSONTyped(json, false);
}

export function RegisterCardOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCardOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'card': !exists(json, 'card') ? undefined : CardFromJSON(json['card']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function RegisterCardOutputToJSON(value?: RegisterCardOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'card': CardToJSON(value.card),
        'error': value.error,
    };
}

